/* Fann Bliss — Personalize section: pick-a-blank studio.
   Tiles are rendered by Liquid; this script swaps the photo, renders the
   product's option swatches (colour / size) and points the button at the
   chosen variant. Reads the JSON the section prints in script[data-fh-blanks]. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function money(cents) {
    if (window.FannHome && window.FannHome.money) return window.FannHome.money(cents);
    var n = cents / 100; return 'AED ' + (n % 1 === 0 ? n : n.toFixed(2));
  }

  function initStudio(studio) {
    if (studio.__fhPk) return; studio.__fhPk = true;
    var dataEl = $('script[data-fh-blanks]', studio); if (!dataEl) return;
    var products; try { products = (JSON.parse(dataEl.textContent || '{}').products) || []; } catch (_) { return; }
    if (!products.length) return;
    var root = studio.closest('[data-fh-section]') || document;
    var grid = $('[data-fh-pkgrid]', root), stage = $('[data-fh-stage]', studio), img = $('[data-fh-stageimg]', studio), sold = $('[data-fh-sold]', studio);
    var title = $('[data-fh-pktitle]', studio), price = $('[data-fh-pkprice]', studio), opts = $('[data-fh-opts]', studio), cta = $('[data-fh-continue]', studio), ctaLabel = cta && $('[data-fh-ctalabel]', cta);
    var tpl = studio.getAttribute('data-continue') || 'Personalize this [item]';
    var kinds = (studio.getAttribute('data-kinds') || 'mug,tumbler,bottle,coaster').split(',').map(function (k) { return k.trim(); }).filter(Boolean);
    var itemWord = studio.getAttribute('data-item') || 'blank', colourLabel = studio.getAttribute('data-colour') || 'Colour', fromLabel = studio.getAttribute('data-from') || 'From';
    var swatches = {};
    (studio.getAttribute('data-swatches') || '').split(',').forEach(function (pair) { var i = pair.indexOf(':'); if (i > 0) swatches[pair.slice(0, i).trim().toLowerCase()] = pair.slice(i + 1).trim(); });

    function hexFor(name) {
      var n = String(name).toLowerCase().trim();
      if (swatches[n]) return [swatches[n]];
      var parts = n.split(/\s*[-\/]\s*/);
      if (parts.length === 2 && swatches[parts[0]] && swatches[parts[1]]) return [swatches[parts[0]], swatches[parts[1]]];
      var f = Object.keys(swatches).filter(function (k) { return n.indexOf(k) > -1; }).sort(function (a, b) { return b.length - a.length; })[0];
      return f ? [swatches[f]] : null;
    }
    function isColour(n) { return /colou?r/i.test(n); }
    function kindOf(p) { var t = (p.type || '') + ' ' + (p.t || ''); return kinds.filter(function (k) { return new RegExp(k, 'i').test(t); })[0] || itemWord; }

    var cur = null, sel = {};
    function byHandle(h) { return products.filter(function (p) { return p.h === h; })[0]; }
    function optIndex(n) { for (var i = 0; i < cur.opts.length; i++) if (cur.opts[i].n === n) return i; return -1; }
    function matches(v, s) { return Object.keys(s).every(function (n) { var i = optIndex(n); return i < 0 || v.o[i] === s[n]; }); }
    function variant() {
      if (!cur.opts.length) return cur.vars[0] || null;
      if (!Object.keys(sel).length) return null;
      var m = cur.vars.filter(function (v) { return matches(v, sel); });
      if (!m.length) return null;
      if (Object.keys(sel).length === cur.opts.length) return m[0];
      return m.filter(function (v) { return v.a; })[0] || m[0];
    }
    function renderOpts() {
      if (!opts) return;
      opts.innerHTML = '';
      cur.opts.forEach(function (o, oi) {
        var row = document.createElement('div'); row.className = 'fh-colors';
        var lab = document.createElement('span'); lab.className = 'fh-pk-optname'; lab.textContent = isColour(o.n) ? colourLabel : o.n; row.appendChild(lab);
        var wrap = document.createElement('div'); wrap.className = 'fh-swatches';
        o.v.forEach(function (val) {
          var other = {}; Object.keys(sel).forEach(function (k) { if (k !== o.n) other[k] = sel[k]; });
          var avail = cur.vars.some(function (v) { return v.o[oi] === val && v.a && matches(v, other); });
          var hex = isColour(o.n) ? hexFor(val) : null;
          var b = document.createElement('button'); b.type = 'button';
          if (hex) { b.className = 'fh-swatch' + (hex.length > 1 ? ' fh-duo' : ''); b.style.setProperty('--c', hex[0]); if (hex[1]) b.style.setProperty('--c2', hex[1]); b.setAttribute('aria-label', val); b.title = val; }
          else { b.className = 'fh-size'; b.textContent = val; }
          b.setAttribute('aria-pressed', sel[o.n] === val ? 'true' : 'false');
          if (!avail) b.setAttribute('aria-disabled', 'true');
          b.addEventListener('click', function () { if (sel[o.n] === val) delete sel[o.n]; else sel[o.n] = val; renderOpts(); renderStage(); });
          wrap.appendChild(b);
        });
        row.appendChild(wrap); opts.appendChild(row);
      });
    }
    function swapImg(src) {
      if (!img || !src || img.getAttribute('data-src') === src) return;
      img.setAttribute('data-src', src); img.classList.add('fh-swap');
      var pre = new Image();
      pre.onload = function () { if (img.getAttribute('data-src') !== src) return; img.srcset = src.replace(/width=800/, 'width=400') + ' 400w, ' + src + ' 800w'; img.src = src; img.classList.remove('fh-swap'); };
      pre.onerror = function () { img.classList.remove('fh-swap'); };
      pre.src = src;
    }
    function renderStage() {
      var v = variant(), full = cur.opts.length ? Object.keys(sel).length === cur.opts.length : true;
      swapImg((v && v.img) || cur.img);
      if (img) img.alt = cur.t || '';
      if (title) title.textContent = cur.l;
      if (price) price.textContent = v ? money(v.p) : ((cur.min !== cur.max ? fromLabel + ' ' : '') + money(cur.min));
      if (sold) sold.hidden = !(v && full && !v.a);
      if (cta) { cta.href = cur.u + (v ? (cur.u.indexOf('?') > -1 ? '&' : '?') + 'variant=' + v.id : ''); (ctaLabel || cta).textContent = tpl.replace('[item]', kindOf(cur)); }
    }
    function select(h, fromTap) {
      var p = byHandle(h); if (!p) return; cur = p; sel = {};
      $$('.fh-pk', grid).forEach(function (t) { t.setAttribute('aria-selected', t.getAttribute('data-h') === h ? 'true' : 'false'); });
      renderOpts(); renderStage();
      if (fromTap && stage) { var r = stage.getBoundingClientRect(); if (r.top < 0 || r.bottom > window.innerHeight) stage.scrollIntoView({ block: 'nearest', behavior: reduce ? 'auto' : 'smooth' }); }
      if (fromTap && stage && !reduce && stage.animate) stage.animate([{ transform: 'scale(.985)' }, { transform: 'scale(1)' }], { duration: 320, easing: 'cubic-bezier(.2,.8,.2,1)' });
    }
    if (grid) {
      grid.addEventListener('click', function (e) { var t = e.target.closest('.fh-pk'); if (t) select(t.getAttribute('data-h'), true); });
      grid.addEventListener('keydown', function (e) {
        var tiles = $$('.fh-pk', grid), i = tiles.indexOf(document.activeElement); if (i < 0) return;
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0; if (!d) return;
        e.preventDefault(); var n = tiles[(i + d + tiles.length) % tiles.length]; n.focus(); select(n.getAttribute('data-h'), false);
      });
    }
    if (!grid) return;
    var first = $('.fh-pk[aria-selected="true"]', grid) || $('.fh-pk', grid);
    if (first) select(first.getAttribute('data-h'), false);
  }

  function init(scope) { $$('[data-fh-studio]', scope || document).forEach(initStudio); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { if (e.target) { $$('[data-fh-studio]', e.target).forEach(function (s) { s.__fhPk = false; }); init(e.target); } });
})();
